export default __webpack_public_path__ + "static/media/Orla_9781408355145.be16bd09.jpg";